import React from 'react';
import { Typography, Button, Row, Progress } from 'antd';
import { getFormattedSum } from 'common/helpers/numbers.helper';
import { ERoutesPrivate } from 'common/models/routesModel';
import { ReactComponent as BitecoinIcon } from 'app/assets/images/bitecoinIcon.svg';
import { history } from 'app/store';
import { MenuItemImage } from 'entities/Menu/components/MenuItemImage';
import { IBitecoinRewardModel } from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  item: IBitecoinRewardModel;
  bitecoinBalance: number;
  onRewardItemClick(item: IBitecoinRewardModel): void;
  isDisabled?: boolean;
  isInCart?: boolean;
}

type AllProps = IComponentProps;

export const BitecoinRewardItemCard: React.FC<AllProps> = (props) => {
  const { item, bitecoinBalance, onRewardItemClick, isDisabled, isInCart } = props;
  const {
    name,
    menuItem: { image },
    priceInBitecoins,
  } = item;

  const goToCart = () => {
    history.push(ERoutesPrivate.Bag);
  };

  return (
    <div className="menu-card menu-card_height_fixed d-flex d-flex_column d-flex_justify-between">
      <div className="menu-card__content">
        <div className="d-flex d-flex_column d-flex_justify-between d-flex__item_full">
          {name && (
            <Typography.Paragraph ellipsis={{ rows: 3 }} className="menu-card__header mb-0">
              {name}
            </Typography.Paragraph>
          )}

          <div className="menu-card__price-scale">
            <span>
              {bitecoinBalance} / {priceInBitecoins}
            </span>
            <Progress
              percent={(bitecoinBalance / priceInBitecoins) * 100}
              showInfo={false}
              railColor="#EEEEEE"
              strokeColor="#FBE122"
            />
          </div>
        </div>

        <div>
          {image && (
            <div className="menu-card__image-wrapper">
              <MenuItemImage src={image} className="menu-card__image" alt={name} />
            </div>
          )}
        </div>
      </div>

      <div className="menu-card__content d-flex_align-center">
        {isInCart ? (
          <Button
            size="large"
            block
            className="btn"
            type="default"
            onClick={goToCart}
            disabled={bitecoinBalance < priceInBitecoins || isDisabled}
          >
            View in Bag
          </Button>
        ) : (
          <Button
            size="large"
            block
            className="btn"
            type="primary"
            onClick={() => onRewardItemClick(item)}
            disabled={bitecoinBalance < priceInBitecoins || isDisabled}
          >
            Redeem
          </Button>
        )}
        <div className="menu-card__footer-reward-price">
          <Row justify="start" align="middle" gutter={[8, 0]}>
            <BitecoinIcon />
            <span className="bitecoin-wallet__balance">{getFormattedSum(priceInBitecoins)}</span>
          </Row>
        </div>
      </div>
    </div>
  );
};
